import api from './clients';
import { buildQueryString } from '../lib/pagination';

export type Venta = {
  id?: number;
  fecha?: string;
  total?: number;
  [key: string]: any;
};

export type CreateVentaDto = {
  fecha?: string;
  items?: Array<{ productoId: number; cantidad: number; precio: number }>;
  [key: string]: any;
};

export type VentaStats = {
  totalVentas?: number;
  totalIngresos?: number;
  [key: string]: any;
};

export type TopProduct = {
  productoId?: number;
  nombre?: string;
  totalVendido?: number;
  [key: string]: any;
};

interface GetSalesParams {
  estado?: string;
  cliente?: string;
  fechaInicio?: string;
  fechaFin?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export const salesApi = {
  getAll: async (params?: GetSalesParams) => {
    const query = buildQueryString({
      estado: params?.estado,
      cliente: params?.cliente,
      fechaInicio: params?.fechaInicio,
      fechaFin: params?.fechaFin,
      search: params?.search,
      page: params?.page,
      limit: params?.limit,
    });

    const response = await api.get(`/sales${query}`);
    return response.data;
  },

  getById: async (id: number): Promise<Venta> => {
    const response = await api.get(`/sales/${id}`);
    return response.data.data;
  },

  create: async (data: CreateVentaDto): Promise<Venta> => {
    const response = await api.post('/sales', data);
    return response.data.data;
  },

  update: async (id: number, data: Partial<CreateVentaDto>): Promise<Venta> => {
    const response = await api.put(`/sales/${id}`, data);
    return response.data.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/sales/${id}`);
  },

  getStats: async (): Promise<VentaStats> => {
    const response = await api.get('/sales/estadisticas');
    return response.data.data;
  },

  getMensuales: async (meses: number = 6): Promise<Array<{ mes: string; ventas: number }>> => {
    const response = await api.get('/sales/mensuales', { params: { meses } });
    return response.data.data;
  },

  getTopProducts: async (limit: number = 10, fechaInicio?: string, fechaFin?: string): Promise<TopProduct[]> => {
    const response = await api.get('/sales/top-products', {
      params: { limit, fechaInicio, fechaFin },
    });
    return response.data.data;
  },

  getDiarias: async (dias: number) => {
    const response = await api.get(`/reports/ventas/diarias?dias=${dias}`);
    return response.data.data;
  },
};